const sortDictionary = (dictionary: Record<any, any>, label: string) =>
  dictionary.sort((a: Record<any, any>, b: Record<any, any>) => {
    if (a[label] < b[label]) return -1;
    if (a[label] > b[label]) return 1;
    return 0;
  });

export default sortDictionary;
